"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAttachmentValues = void 0;
var _attachment = require("./attachment.decode");
var _base64Helpers = require("./base64Helpers");
var getAttachmentValues = function getAttachmentValues(attachmentBase64) {
  var _decodeBase64Attachme = (0, _attachment.decodeBase64Attachment)(attachmentBase64),
    bytes = _decodeBase64Attachme.bytes,
    fileName = _decodeBase64Attachme.name;
  var base64 = (0, _base64Helpers.byteArrayToBase64)(bytes);
  var fileSize = bytes.length;
  var extensionIndex = fileName.lastIndexOf('.');
  var fileExtension = fileName.substr(extensionIndex);
  return {
    fileName: fileName,
    fileExtension: fileExtension,
    fileSize: fileSize,
    base64: base64,
    fileExtensionWithoutPeriod: fileExtension.substr(1)
  };
};
exports.getAttachmentValues = getAttachmentValues;